import {equals, find, flow, pipe} from '@logistics-frontend/utils'

import {accountGetter, passportGetter} from '../../../repo/passport/getters'
import type {PassportAccount, PassportResponse} from '../../../repo/passport/types'

const getAccounts = passportGetter('accounts')
const getDefaultUid = passportGetter('default_uid')
const getDefaultEmail = accountGetter('defaultEmail') as (account?: PassportAccount) => string | undefined

export function toDefaultEmail(response: PassportResponse): string | undefined {
  const defaultUid = getDefaultUid(response)
  const byDefaultUid = flow(accountGetter('uid'), equals(defaultUid))

  return pipe(
    //
    response,
    getAccounts,
    find(byDefaultUid),
    getDefaultEmail,
  )
}
